// extracted by mini-css-extract-plugin
export default {"infoContainer":"InfoIcon_infoContainer__FB29s","infoIcon":"InfoIcon_infoIcon__AwpfH","tooltip":"InfoIcon_tooltip__PjbnG"};